import React from 'react';
import { Box } from '../../../../wag-react/next-components/box';
import { Flex } from '../../../../wag-react/next-components/Flex';
import { Typography } from '../../../../wag-react/components/Typography';
import { Image } from '../../../../wag-react/next-components/image';

// Import caregiver images
import caregiver1 from '../../assets/caregivers/Avatar-0.svg';
import caregiver2 from '../../assets/caregivers/Avatar-1.svg';
import caregiver3 from '../../assets/caregivers/Avatar-2.svg';
import caregiver4 from '../../assets/caregivers/Avatar-3.svg';
import starRating from '../../assets/star-rating.svg';
export const CaregiverRating = () => {
  return <Flex alignItems="flex-start" mt={3} data-sentry-element="Flex" data-sentry-component="CaregiverRating" data-sentry-source-file="index.tsx">
      {/* Caregiver images */}
      <Flex alignItems="center" pt={["10px", "10px", "0px"]} pr={["12px", "12px", "0px"]} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Box width={["32px", "32px", "48px"]} height={["32px", "32px", "48px"]} borderRadius={["34px", "34px", "48px"]} overflow="hidden" border="0px solid white" position="relative" zIndex={1} data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <Image src={caregiver1} alt="Caregiver" width="100%" height="100%" objectFit="cover" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
        </Box>
        <Box width={["32px", "32px", "48px"]} height={["32px", "32px", "48px"]} borderRadius={["34px", "34px", "48px"]} overflow="hidden" border="0px solid white" position="relative" left={["-8px", "-8px", "-12px"]} zIndex={2} data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <Image src={caregiver2} alt="Caregiver" width="100%" height="100%" objectFit="cover" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
        </Box>
        <Box width={["32px", "32px", "48px"]} height={["32px", "32px", "48px"]} borderRadius={["34px", "34px", "48px"]} overflow="hidden" border="0px solid white" position="relative" left={["-16px", "-16px", "-24px"]} zIndex={3} data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <Image src={caregiver3} alt="Caregiver" width="100%" height="100%" objectFit="cover" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
        </Box>
        <Box width={["32px", "32px", "48px"]} height={["32px", "32px", "48px"]} borderRadius={["34px", "34px", "48px"]} overflow="hidden" border="0px solid white" position="relative" left={["-24px", "-24px", "-36px"]} zIndex={4} data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <Image src={caregiver4} alt="Caregiver" width="100%" height="100%" objectFit="cover" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
        </Box>
      </Flex>
      
      {/* Rating and text */}
      <Flex flexDirection="column" ml={-24} style={{
      gap: '4px'
    }} pt={1} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Box display="flex" width="103px" height="18px" alignItems="flex-start" style={{
        gap: '4px'
      }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <Image src={starRating} alt="5-star rating" width="100%" height="100%" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
        </Box>
        <Typography color="#474747" fontSize={["13px", "13px", "14px"]} fontStyle="normal" lineHeight="20px" letterSpacing="0px" mt={0} style={{
        fontFamily: '"Hero New", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        fontWeight: 400
      }} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          400K+ Pet Caregivers nationwide
        </Typography>
      </Flex>
    </Flex>;
};